import { db } from '@/mocks/db/schema';
import type {
  IndividualPortalApproval,
  IndividualPortalAttendance,
  IndividualPortalRequest,
  IndividualPortalTask,
} from '@/mocks/db/schema';

export interface PortalLoaderData {
  attendance: IndividualPortalAttendance | null;
  tasks: IndividualPortalTask[];
  approvals: IndividualPortalApproval[];
  requests: IndividualPortalRequest[];
}

export async function loadPortalData(): Promise<PortalLoaderData> {
  const [attendances, tasks, approvals, requests] = await Promise.all([
    db.individualPortalAttendance.toArray(),
    db.individualPortalTasks.orderBy('sortOrder').toArray(),
    db.individualPortalApprovals.orderBy('sortOrder').toArray(),
    db.individualPortalRequests.orderBy('sortOrder').toArray(),
  ]);

  return {
    attendance: attendances[0] ?? null,
    tasks,
    approvals,
    requests,
  };
}
